import { Component, OnInit } from '@angular/core';
import { PopinService } from '../popin.service';
import { LocalStorageService } from '../../../services/storage/local-storage.service';
import { ToasterEventsService } from '../../../toaster/toaster-events.service';
import { ThemeEventsService } from '../../../theme/theme-event.service';
import { Theme } from '../../../decorators/theme.decorator';

@Component({
  selector: 'sc-bottom-popin',
  styleUrls: ['./bottom-popin.component.css', './../blackshield.component.css'],
  templateUrl: './bottom-popin.component.html'
})
export class BottomPopinComponent implements OnInit {
  @Theme() public theme: string;
  public isPopinDeployed: boolean;
  public currentScroll = 0;

  constructor(
    private popinService: PopinService,
    private localStorage: LocalStorageService,
    private themeEventsService: ThemeEventsService,
    private toasterService: ToasterEventsService
  ) {}

  public ngOnInit() {
    this.popinService.closeBottomPopinEmitter.subscribe(() => {
      this.isPopinDeployed = false;
    });
    this.popinService.openBottomPopinEmitter.subscribe(() => {
      this.isPopinDeployed = true;
    });
  }

  public closePopin() {
    this.toasterService.warnEvent('Warning, data not saved');
    this.popinService.closeBottomPopin();
  }
}
